import { render } from "./ShareReport.vue?vue&type=template&id=36b44fc1&scoped=true&ts=true"
import script from "./ShareReport.vue?vue&type=script&lang=ts"
export * from "./ShareReport.vue?vue&type=script&lang=ts"

import "./ShareReport.vue?vue&type=style&index=0&id=36b44fc1&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b44fc1"]])

export default __exports__